"use client";

import { useState } from "react";

export default function ThemeToggle() {
  // サーバーレンダリング時はdocumentが無いため既定でダーク扱いにし、
  // クライアントでは実際に<html>へ付与されているクラス(inline scriptで確定済み)を読む。
  // サーバー/クライアントで値が食い違いうる(localStorageが"light"だった場合)ため
  // suppressHydrationWarningで許容する。
  const [isDark, setIsDark] = useState(() =>
    typeof document !== "undefined"
      ? document.documentElement.classList.contains("dark")
      : true
  );

  function toggle() {
    const next = !isDark;
    setIsDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("theme", next ? "dark" : "light");
  }

  return (
    <button
      type="button"
      onClick={toggle}
      suppressHydrationWarning
      className="rounded-md border border-zinc-300 bg-white px-2.5 py-1 text-xs font-medium text-zinc-600 hover:bg-zinc-100 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-800"
    >
      {isDark ? "ダーク" : "ライト"}
    </button>
  );
}
